<template>
  <div>
    <div class="head-box">
      <h4 class="c-flex c-flex-item">
        服务资源总分排行榜
      </h4>
      <div class="c-flex c-flex-item">
        <!-- <el-input
          placeholder="搜索管家姓名"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click.native="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input> -->
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table ref="table" :data="fpi.data" empty-text="暂无数据" height="calc(100% - 50px)">
          <el-table-column fixed label="排名" width="60px">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <c-table :fields="extFields"></c-table>
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="getScoreDetail(scope.row)">
                    查看得分明细
                  </el-dropdown-item>
                  <!-- <el-dropdown-item
                    v-if="scope.row.state == 0"
                    @click.native="doEnable(scope.row._id)"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 1"
                    @click.native="doDisable(scope.row._id)"
                  >
                    禁用
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="doRemove(scope.row._id)">
                    删除
                  </el-dropdown-item> -->
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :title="scoreDetail.formData.userName + '得分明细'"
      :visible.sync="scoreDetail.show"
      :close-on-click-modal="false"
      width="800px"
    >
      <el-table ref="table2" :data="scoreDetail.fpi.data" empty-text="暂无数据" height="500px">
        <c-table :fields="scoreDetailFields"></c-table>
      </el-table>
      <el-pagination
        class="pagination"
        @size-change="pageSizeChange"
        @current-change="pageChange"
        :current-page="scoreDetail.fpi.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="scoreDetail.fpi.rows"
        layout="total, sizes, prev, pager, next, jumper"
        :total="scoreDetail.fpi.total"
      ></el-pagination>
    </el-dialog>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'scoreUser',
  data() {
    window.$this = this;
    return {
      name: 'scoreUser',
      fpi: {
        data: []
      },
      searchValue: '',
      openDetail: false,
      extFields: [],
      formData: {
        exts: {}
      },
      rules: this.$util.rules,
      options: {},
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      scoreDetail: {
        show: false,
        formData: { exts: {} },
        fpi: {
          page: 1,
          rows: 20,
          data: []
        }
      },
      scoreDetailFields: []
    };
  },
  mounted() {
    this.osg.getFields('scoreUser', () => {
      this.osg.getFpi();
      this.getData();
    });
    this.osg.getFields('scoreDetail', () => {}, null, 'scoreDetailFields');
  },
  methods: {
    pageSizeChange(pageSize) {
      if (this.scoreDetail.show) {
        this.scoreDetail.fpi.rows = pageSize;
        this.getScoreDetail();
      } else {
        this.fpi.rows = pageSize;
        this.getData();
      }
    },
    pageChange(currentPage) {
      if (this.scoreDetail.show) {
        this.scoreDetail.fpi.rows = currentPage;
        this.getScoreDetail();
      } else {
        this.fpi.page = currentPage;
        this.getData();
      }
    },
    getData() {
      let params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        'is:state|integer#and': 1,
        // 'regex:userName|string#or': this.searchValue,
        sortField: 'scoreTotal',
        sortOrder: 'desc'
      };
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('biz/scoreUser/query.do', params, res => {
        res.data.map(item => {
          item.exts = item.exts || {};
        });
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    // 查看管家得分明细
    getScoreDetail(item) {
      if (item) {
        this.scoreDetail.formData = item;
      }
      this.scoreDetail.show = true;
      this.osg.ajax(
        'biz/scoreDetail/query.do',
        {
          page: this.scoreDetail.fpi.page || 1,
          rows: this.scoreDetail.fpi.rows || 20,
          'is:state|integer#and': 1,
          'is:userId|string#and': this.scoreDetail.formData.userId,
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.scoreDetail.fpi = res;
          this.scoreDetail.show = true;
        }
      );
    }
    // doEnable(id) {
    //   this.osg.ajax('biz/scoreUser/enable.do', { id }, () => {
    //     this.osg.toast('启用成功');
    //     this.getData();
    //   });
    // },
    // doDisable(id) {
    //   this.osg.ajax('biz/scoreUser/disable.do', { id }, () => {
    //     this.osg.toast('禁用成功');
    //     this.getData();
    //   });
    // },
    // doRemove(id) {
    //   this.osg.confirm('是否确认删除？', () => {
    //     this.osg.ajax('biz/scoreUser/delete.do', { id }, () => {
    //       this.osg.toast('删除成功');
    //       this.getData();
    //     });
    //   });
    // }
  }
};
</script>
<style lang="scss"></style>
